import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs } from 'yw-ui.v2/dist/components';
import { getCurrentStepName } from '../../functions/helpers';
import { PSR_REGISTER, PSR_REVIEW, YW_URLS } from '../../settings/urls';

const AppBreadcrumbs = ({ pathname, representative }) => {
  const gotToStartPage = () => {
    if (pathname.includes(PSR_REGISTER)) {
      return window.location.hostname !== 'localhost'
        ? `${window.location.hostname}${process.env.PUBLIC_URL}${PSR_REGISTER}`
        : `${process.env.PUBLIC_URL}${PSR_REGISTER}`;
    } else {
      return window.location.hostname !== 'localhost'
        ? `${window.location.hostname}${process.env.PUBLIC_URL}${PSR_REVIEW}`
        : `${process.env.PUBLIC_URL}${PSR_REVIEW}`;
    }
  };

  const getCrumbs = () => {
    if (pathname === PSR_REGISTER || pathname === PSR_REVIEW) {
      return [
        {
          label: 'Home',
          to: YW_URLS.HOME,
          isExternal: true,
        },
        {
          label: 'Priority Services',
          isExternal: false,
        },
      ];
    } else {
      return [
        {
          label: 'Home',
          to: YW_URLS.HOME,
          isExternal: true,
        },
        {
          label: 'Priority Services',
          isExternal: true,
          to: gotToStartPage(),
        },
        {
          label: getCurrentStepName(pathname, representative),
        },
      ];
    }
  };
  return <Breadcrumbs showIcon={true} crumbs={getCrumbs()} addNbsp={false} id="breadcrumbs" />;
};

AppBreadcrumbs.propTypes = {
  pathname: PropTypes.string,
  representative: PropTypes.string,
};

export default AppBreadcrumbs;
